import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'mapfre-auditlib-circle',
  templateUrl: './circle.component.html',
  styleUrls: ['./circle.component.scss']
})
export class CircleComponent implements OnInit {

  constructor() { }

  @Input() name: string;
  @Input() title = true;
  @Input() img;

  ngOnInit() { }

  getAlias(name) {
    return name ? name.charAt(0) : null;
  }

}
